module.exports = __webpack_public_path__ + "img/hocl.3dc92b09.svg";